import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageview, initPostHog } from 'utils/feedbackAnalytics';

/**
 * Captures SPA route changes. The first pageview is handled by initPostHog().
 */
const PostHogPageviewTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    initPostHog();
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    capturePageview();
  }, [location.pathname, location.search]);

  return null;
};

export default PostHogPageviewTracker;
